import {
  forwardRef,
  Ref,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { ComplexField } from "./ComplexField";
import { CFieldType } from "../../../types/RecordInterfaces";
import StrUtils from "../../../utils/StrUtils";
import { Whisper, Popover as RPopover } from "rsuite";

interface Props {
  field: any;
  inputSize: any;
  existingValue: CFieldType[];
  disabled: boolean;
  onChange: (newVal: any) => void;
  type: "Phone" | "URL" | "Email";
}

const ComplexFieldCreate = (
  { existingValue, field, inputSize, disabled, onChange, type }: Props,
  ref?: Ref<HTMLInputElement>
) => {
  const [isEditing, setIsEditing] = useState(false);
  const [values, setValues] = useState<CFieldType[]>(existingValue || []);
  const whisperRef = useRef<any>();

  useEffect(() => {
    setValues(existingValue || []);
  }, [existingValue]);

  // @ts-ignore
  useImperativeHandle(ref, () => ({
    focus: () => {
      whisperRef?.current?.open();
    },
  }));

  return (
    <Whisper
      preventOverflow
      ref={whisperRef}
      placement="autoVerticalStart"
      trigger={isEditing ? "none" : "click"}
      speaker={
        <RPopover
          style={{
            boxShadow: "0 1px 8px rgba(0,0,0,0.12)",
            filter: "drop-shadow(var(--rs-popover-shadow))",
          }}
          className="p-0"
          arrow={false}
        >
          <ComplexField
            recordID={StrUtils.uuidv4()}
            field={field}
            onUpdate={(payload: any) => {
              onChange(payload.payload);
            }}
            closeRecord={() => {
              whisperRef?.current?.close();
              setIsEditing(false);
            }}
            existingValues={existingValue}
            setIsEditing={setIsEditing}
            values={values}
            type={type}
            setValues={setValues}
          />
        </RPopover>
      }
    >
      <div
        id={`record-input-${field.APIName}`}
        style={{
          height:
            inputSize === "sm"
              ? "calc( 0.45em + 1.25rem + 5px)"
              : "calc( 1.5em + 1.25rem + 5px)",
          borderRadius: "0.25rem",
          fontSize: "0.875rem",
          lineHeight: 1.5,
          padding: inputSize === "sm" ? "0.25rem 0.5rem" : "0.625rem 0.75rem",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          background: disabled ? "#c6cac7" : "unset",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        className="border"
        onClick={disabled ? () => {} : () => whisperRef?.current?.open()}
      >
        {values?.length > 0 ? (
          <span>
            {values
              .map((val) => val[field?.FieldType as "Email" | "Phone" | "URL"])
              .join(", ")}
          </span>
        ) : (
          <span>--</span>
        )}
      </div>
    </Whisper>
  );
};

const ComplexFieldCreateFR = forwardRef(ComplexFieldCreate);

export default ComplexFieldCreateFR;
